import { render, staticRenderFns } from "./Karen.vue?vue&type=template&id=1c916b72&"
import script from "./Karen.vue?vue&type=script&lang=js&"
export * from "./Karen.vue?vue&type=script&lang=js&"
import style0 from "./Karen.vue?vue&type=style&index=0&id=1c916b72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports